import React from 'react';

import { Modal, Header, Body, Footer, FooterButton } from './modalElements';
import { ModalContent } from './styles';

export default function YesNoModal({ confirm, modalInfo }) {
  return (
    <Modal>
      <Header>{modalInfo.title}</Header>
      <Body>
        <ModalContent
          dangerouslySetInnerHTML={{
            __html: modalInfo.body,
          }}
        ></ModalContent>
      </Body>
      <Footer>
        <FooterButton label="Yes" onClick={() => confirm(true)} />
        <FooterButton label="No" onClick={() => confirm(false)} autoFocus />
      </Footer>
    </Modal>
  );
}
